<template>
    <div class="actions-card" v-if="cardArr != null && pageSetup != null">
        <!-- {{cardID}} -->
        <!-- {{title}} -->
        <div class="container">
            <div class="card-title">
                <h2>{{cardArr[0].action_title}}</h2>
            </div>
            <div class="column-container">
                <div class="col-left">
                    <div class="card-img">
                        <img :src="cardArr[0].action_img" alt="">
                    </div>
                </div>
                <div class="col-right">
                    <div class="desc-info">
                        <p v-for="item in cardArr[0].action_desc_full">{{item.desc}}</p>
                    </div>
                    <div class="bottom-info">
                        <div class="action-card-contacts" v-if="cardArr[0].actions_info.office_visible.value == 'true' || cardArr[0].actions_info.phone_visible.value == 'true' || cardArr[0].actions_info.site_visible.value == 'true'">
                            <h4>{{pageSetup.action_card_all_info}}</h4>
                            <div class="item action-adres" v-if="cardArr[0].actions_info.office_visible.value == 'true'">
                                <span class="label">{{pageSetup.action_card_office}}</span>
                                <div class="item-desc">
                                    <svg-icon icon-class="pin" className="icon-action icon-pin"/>
                                    <p>{{cardArr[0].actions_info.office_adres}}</p>
                                </div>
                            </div>
                            <div class="item action-phone" v-if="cardArr[0].actions_info.phone_visible.value == 'true'">
                                <span class="label">{{pageSetup.action_card_call_center}}</span>
                                <div class="item-desc">
                                    <svg-icon icon-class="mobile" className="icon-action icon-mobile"/>
                                    <a :href="'tel:' + cardArr[0].actions_info.phone">{{cardArr[0].actions_info.phone}}</a>
                                </div>
                            </div>
                            <div class="item action-site" v-if="cardArr[0].actions_info.site_visible.value == 'true'">
                                <span class="label">{{pageSetup.action_card_site}}</span>
                                <div class="item-desc">
                                    <svg-icon icon-class="click" className="icon-action icon-click"/>
                                    <a :href="cardArr[0].actions_info.link_to_site.link" target="_blank" class="link-to-site">{{cardArr[0].actions_info.link_to_site.name}}</a>
                                </div>
                            </div>
                        </div>
                        <div class="btn-to-call-center">
                            <a href="#">{{pageSetup.action_card_btn}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <sharePost :shareArr="[{title: pageSetup.action_card_soc_title, data_title: cardArr[0].action_title, data_link: 'https://sales.bazis.kz/actions/' + cardID}]" class="action-card-share"></sharePost>
        </div>
    </div>
</template>

<script>
    // var convert = require('cyrillic-to-latin');
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    import {mapGetters} from 'vuex'
    import sharePost from '@/components/share/share-post.vue'
    export default {
        name: 'action-card',
        components: {
            sharePost,
        },
        data () {
            return {
                cardID: this.$route.params.id,
                title: this.$route.params.title,
                cardArr: null,
            }
        },
        methods: {
            cytTolat(text) {
                return cyrillicToTranslit().transform(text, "_").replace(/!/g,'').replace(/:/g,'').replace(/–/g,'').replace(/-/g,'').replace(/«/g,'').replace(/»/g,'').replace(/,/g,'').toLowerCase();
            },
            getData() {
                if (this.actionsItemsFilter.length) {
                    var data = this.actionsItemsFilter;
                    console.log(data, 'asdasasd')
                    var filteredItems = data.filter(item => {
                        return this.cytTolat(item.action_title) === this.cardID || item.action_key_word === this.cardID
                    });
                    this.cardArr = filteredItems;
                    this.$store.commit('setCustomCrumb', this.cardArr[0].action_title);
                }
                
            }
        },
        computed: mapGetters({
            pageSetup: 'loadActionPage',
            actionsItems: 'loadActionsItems',
            actionsItemsDefault: 'loadActionsItemsDefault',
            actionsItemsFilter: 'loadActionsItemsFilter',
            actionCardAnimate: 'loadActionCardAnimateStatus',
        }),
        beforeCreate() {
            this.$store.dispatch('getActionsItems');
            this.$store.dispatch('getActionPageData');
        },
        created () {
            this.$store.commit('setCustomCrumb', this.title);
            document.body.dataset.page = 'actions-card';
        },
        mounted () {
            this.getData();
            this.$store.watch(
                (state) => state.actionsItemsFilter,
                (newValue) => {
                    if (newValue) {
                        this.getData();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/actions/action-card.scss';
</style>